import { ROUTE } from '../../routes';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { api } from '../../configs/api';
import { getAppHeader } from '../../configs/config';
import { nextStepCredStepper } from '../../configs/utils';
import { ACTION } from './types';
import SharedPropsService from '../../SharedPropsService';
import { DigioKycStatus } from "../../configs/constants";
import { WIDGET } from "@voltmoney/schema";
let pollInterval;
let responseFromDigio;
export const GoToNumber = async (action, _datastore, { navigate, goBack }) => {
    // await goBack();
    await AsyncStorage.setItem('first_time', 'true');
    navigate(ROUTE.SPLASH_SCREEN);
};
export const closeModal = async (action, _datastore, { goBack, showPopup }) => {
    await goBack();
    await showPopup({
        title: 'KYC verification canceled',
        ctaLabel: 'Try again',
        primary: true,
        ctaAction: {
            routeId: ROUTE.BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL,
            type: ACTION.FAILED_VERIFICATION,
            payload: {},
        },
        type: 'FAILED',
        subTitle: 'KYC verification is required for the completion of your loan application',
    });
};
export const failedVerification = async (action, _datastore, { goBack, hidePopup }) => {
    await goBack();
};
export const successVerification = async (action, _datastore, { goBack, navigateToBase, navigateWithClear, network, removeWidgets }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    await removeWidgets(ROUTE.BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL, [
        { id: 'bajajDigioKyc', type: WIDGET.BAJAJ_DIGIO_KYC_MODAL },
    ]);
    await SharedPropsService.setUser(userContextResponse.data);
    const routeObj = await nextStepCredStepper();
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const kycBajajDeepCheckAction = async (action, _datastore, { hidePopup, showPopup, network }) => {
    console.warn("*** kycBajajDeepCheckAction triggered ***");
    await hidePopup();
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    await SharedPropsService.setUser(userContextResponse.data);
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = userContextResponse?.data.linkedApplications[0].applicationId;
    }
    let coBorrowerAccountId;
    const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
    if (await AsyncStorage.getItem("application_id") !== null) {
        coBorrowerAccountId = updatedApplicationResponse.data.currentCoBorrowerAccountId;
    }
    else {
        coBorrowerAccountId = userContextResponse?.data.linkedApplications[0].currentCoBorrowerAccountId;
    }
    const checkDigioStatus = async () => {
        //if popup is closed we do a status check;
        const digioStatusResponse = await network.get(`${api.bajajDigioCoBorrowerDeepCheckStatus}${applicationId}/${coBorrowerAccountId}`, {
            headers: await getAppHeader()
        });
        if (digioStatusResponse?.status === 200) {
            const digioStatus = digioStatusResponse?.data?.stepResponseObject;
            // handle success
            if (digioStatus === DigioKycStatus.COMPLETED) {
                //move ahead
                await showPopup({
                    type: 'SUCCESS',
                    title: 'Aadhaar and PAN verified successfully',
                    subTitle: ' ',
                    ctaLabel: 'Continue',
                    primary: true,
                    ctaAction: {
                        routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                        type: ACTION.SUCCESS_VERIFICATION,
                        payload: {},
                    },
                });
            }
            // handle failed / expired
            else if (digioStatus === DigioKycStatus.EXPIRED
                || digioStatus === DigioKycStatus.FAILED) {
                await showPopup({
                    type: 'FAILED',
                    title: 'Something went wrong',
                    subTitle: ' ',
                    ctaLabel: 'Try again',
                    primary: true,
                    ctaAction: {
                        routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                        type: ACTION.FAILED_VERIFICATION,
                        payload: {},
                    },
                });
            }
            else if (digioStatus === DigioKycStatus.CREATED
                || digioStatus === DigioKycStatus.CANCELLED) {
                // handle cancel
                await showPopup({
                    type: 'FAILED',
                    title: 'KYC verification canceled',
                    subTitle: 'KYC verification is required for the completion of your loan application',
                    ctaLabel: 'Try again',
                    primary: true,
                    ctaAction: {
                        routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                        type: ACTION.FAILED_VERIFICATION,
                        payload: {},
                    },
                });
            }
        }
        else {
            if (digioStatusResponse?.response?.data?.voltErrorCode === 'DIGIO_PAN_MISMATCH') {
                showPopup({
                    type: 'FAILED',
                    title: 'KYC verification canceled',
                    subTitle: `${digioStatusResponse?.response?.data?.message}`,
                    ctaLabel: 'Try again',
                    primary: true,
                    ctaAction: {
                        routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                        type: ACTION.FAILED_VERIFICATION,
                        payload: {},
                    },
                });
            }
            else {
                showPopup({
                    type: 'FAILED',
                    title: 'Something went wrong',
                    subTitle: ' ',
                    ctaLabel: 'Try again',
                    primary: true,
                    ctaAction: {
                        routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                        type: ACTION.FAILED_VERIFICATION,
                        payload: {},
                    },
                });
            }
            //all error cases
        }
        // clearInterval(pollInterval);
    };
    pollInterval = setTimeout(() => {
        checkDigioStatus();
    }, 1000);
};
